var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error-page" }, [
    _c("div", { staticClass: "gradient-panel" }, [
      _c("div", { staticClass: "content-area" }, [
        _c("div", { staticClass: "callout" }, [
          _c(
            "h4",
            { staticClass: "error-title", attrs: { id: "errorTitle" } },
            [
              _c("i", { staticClass: "material-icons warning" }, [
                _vm._v("warning")
              ]),
              _vm._v(" " + _vm._s(_vm.errorTitle) + "\n        ")
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "divider" }),
          _vm._v(" "),
          _c("div", { staticClass: "error-body" }, [
            _c(
              "div",
              {
                staticClass: "semibold description",
                attrs: { id: "errorDescription" }
              },
              [_vm._v(_vm._s(_vm.errorDescription))]
            ),
            _vm._v(" "),
            _c("div", [_vm._v(" " + _vm._s(_vm.errorDetails) + " ")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm.retryAllowed
              ? _c(
                  "button",
                  {
                    staticClass:
                      "button secondary expanded-for-small-only general-margin",
                    attrs: { name: _vm.errorButtonAnalyticsName },
                    on: { click: _vm.retry }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errorButtonText) +
                        "\n          "
                    )
                  ]
                )
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b73ad92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b73ad92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorPage.vue
// module id = null
// module chunks = 